import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateField } from '@mui/x-date-pickers/DateField';
import type { DateValidationError } from '@mui/x-date-pickers/models';
import { useDateFormatPreference } from '@witmetrics/data-store';
import { currentDate, getStartOfDay, parseDate } from '@witmetrics/utils/time';
import { MIN_FIELD_DATE } from './constants';
import { classes, getFieldFormat, styles } from './utils';

export type DateRangeFieldsProps = {
  disablePast?: boolean;
  start: string;
  end: string;
  onChangeStart: (date: string) => void;
  onChangeEnd: (date: string) => void;
};

export default function DateRangeFields({
  disablePast,
  start,
  end,
  onChangeStart,
  onChangeEnd,
}: DateRangeFieldsProps) {
  const dateFormat = useDateFormatPreference();

  const handleChange = (
    onChange: (date: string) => void,
    date: Date | null,
    validationError: DateValidationError
  ) => {
    if (date && !validationError) onChange(date.toISOString());
  };

  const format = getFieldFormat(dateFormat);
  const minDate = disablePast
    ? parseDate(getStartOfDay(currentDate()))
    : MIN_FIELD_DATE;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className={classes.wrapper}>
        <DateField<Date>
          sx={styles.field}
          size="small"
          label="Start"
          format={format}
          minDate={minDate}
          value={parseDate(start)}
          onChange={(date, { validationError }) =>
            handleChange(onChangeStart, date, validationError)
          }
        />
        <span className={classes.separator}>to</span>
        <DateField<Date>
          sx={styles.field}
          size="small"
          label="End"
          format={format}
          minDate={minDate}
          value={parseDate(end)}
          onChange={(date, { validationError }) =>
            handleChange(onChangeEnd, date, validationError)
          }
        />
      </div>
    </LocalizationProvider>
  );
}
